import BaseProxy from './Proxy';

export default class LogoutProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/logout', parameters);
  }
}
